import { useNextUpIncident } from '../hooks/useNextUpIncident'

import type { ColorScheme } from '@hivewatch/dark'
import { Button } from '@hivewatch/dark'

interface IProps {
  colorScheme: ColorScheme
  isActive: boolean
}

export const DarkNextUpButton = ({ colorScheme, isActive }: IProps) => {
  const { label, isDisabled, isLoading, onPress } = useNextUpIncident({
    isEnabled: isActive,
  })

  if (!isActive) return null

  return (
    <Button
      colorScheme={colorScheme}
      data-testid='incidentsPage_tableHeader_nextUpButton_dark'
      disabled={isDisabled}
      isLoading={isLoading}
      onClick={onPress}
      variant='secondary'
    >
      {label}
    </Button>
  )
}
